// Гостевой (моковый) профиль: с ним человек, который еще ни разу не входил,
// попадает сразу в главное меню и видит игру целиком, а не страницу входа на
// пороге. Настоящая авторизация перезаписывает профиль целиком (SET_PLAYER_AUTH),
// вместе с признаком isGuest.
//
// id намеренно остается пустым: по нему завязаны ВСЕ наградные модалки меню
// (реферальные, ежедневная награда, акция за вход, кристаллы за рейтинг,
// напоминание о заданиях) и все запросы к личным данным — гостю они не
// показываются и не отправляются просто потому, что id нет.
export const GUEST_NUMENS = 5000;
export const GUEST_CRYSTALS = 1000;
// Внутри золотой лиги (см. configs/leagues.js): кнопка рейтингового матча и
// шапка показывают золотую иконку, а не блеклую бронзовую
export const GUEST_RATING = 2000;

export const GUEST_PROFILE = {
  id: null,
  name: null,
  isGuest: true,
  numens: GUEST_NUMENS,
  crystals: GUEST_CRYSTALS,
  rating: GUEST_RATING,
  // Гейт согласия с документами гостю показывать нечего: соглашаться от имени
  // несуществующего аккаунта не с чем. Он появится сразу после настоящего
  // входа — там придут настоящие флаги профиля (у новичка они false)
  hasAcceptedPrivacyPolicy: true,
  hasAcceptedLicenseAgreement: true,
  hasConfirmedAdult: true,
};

// Откуда гость пришел в модалку входа. Значения короткие и латиницей: они же
// уходят уровнем события в GameAnalytics (page:LoginRequiredModal:mount:<reason>),
// и по ним видно, какая кнопка реально приводит людей к авторизации
export const LOGIN_REQUIRED_REASONS = {
  HEADER: 'header',
  TUTORIAL: 'tutorial',
  MATCH: 'match',
  CREATE_LOBBY: 'create_lobby',
  SHOP: 'shop',
  INVENTORY: 'inventory',
  PROFILE: 'profile',
  // «Битва с AI Claude Opus»: кнопка меню и промо-модалка. В лобби с ИИ
  // пускают только с настоящим входом — даже зрителем
  AI_MATCH: 'ai_match',
};

// Заголовок модалки входа под ту кнопку, с которой гость на нее наткнулся:
// человек должен понимать, ЗАЧЕМ ему сейчас предлагают войти
export const LOGIN_REQUIRED_MESSAGES = {
  [LOGIN_REQUIRED_REASONS.HEADER]: 'Авторизуйся,\nчтобы сохранять прогресс и играть с другими игроками',
  [LOGIN_REQUIRED_REASONS.TUTORIAL]:
    'Авторизуйся,\nчтобы мы могли начислить тебе награды за прохождение обучения',
  [LOGIN_REQUIRED_REASONS.MATCH]: 'Авторизуйся,\nчтобы присоединиться к матчу',
  [LOGIN_REQUIRED_REASONS.CREATE_LOBBY]: 'Авторизуйся,\nчтобы создать лобби',
  [LOGIN_REQUIRED_REASONS.SHOP]: 'Авторизуйся,\nчтобы посетить магазин с персональными предложениями',
  [LOGIN_REQUIRED_REASONS.INVENTORY]: 'Авторизуйся,\nчтобы посмотреть свою коллекцию',
  [LOGIN_REQUIRED_REASONS.PROFILE]: 'Авторизуйся,\nчтобы посмотреть свой профиль',
  [LOGIN_REQUIRED_REASONS.AI_MATCH]: 'Авторизуйся,\nчтобы сразиться с AI Claude Opus',
};
